module.exports = __webpack_public_path__ + "img/logo3.90245e2f.png";